import { d as l, _ as o } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as s, createElementBlock as c, normalizeClass as r, normalizeStyle as a, createTextVNode as n, createElementVNode as t } from "vue";
const i = l("play-start"), p = /* @__PURE__ */ t("path", {
  d: "M772.7 217.7a32.2 32.1 0 1 0 64.4 0 32.2 32.1 0 1 0-64.4 0zM415.8 679.9c5.9 0 11.5-1.6 16.2-4.5l231.1-134.6c10.9-5.2 18.5-16.3 18.5-29.2 0-11.9-6.4-22.3-16-27.8L439.7 352.2c-5.8-6.7-14.4-10.9-23.9-10.9-17.6 0-31.8 14.4-31.8 32.1 0 .6 0 1.2.1 1.8l-.4.2.5 269c-.1 1.1-.2 2.2-.2 3.4 0 17.7 14.3 32.1 31.8 32.1z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), d = /* @__PURE__ */ t("path", {
  d: "M909.8 306.6c-5.4-10.5-16.3-17.8-28.9-17.8-17.8 0-32.2 14.4-32.2 32.1 0 6 1.7 11.7 4.6 16.5l-.1.1c26.9 52.4 42.1 111.8 42.1 174.7 0 211.6-171.6 383.2-383.2 383.2S128.8 723.8 128.8 512.2 300.4 129.1 512 129.1c62.5 0 121.5 15 173.6 41.5l.2-.4c4.6 2.6 10 4.1 15.7 4.1 17.8 0 32.2-14.4 32.2-32.1 0-13.1-7.9-24.4-19.3-29.4C653.6 81.9 584.9 64.5 512 64.5 264.7 64.5 64.3 265 64.3 512.2S264.7 959.9 512 959.9s447.7-200.4 447.7-447.7c0-74.1-18-144-49.9-205.6z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1);
function f(e, m, _, u, y, h) {
  return s(), c("svg", {
    class: r(e.classes),
    style: a(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, [
    p,
    n(","),
    d
  ], 6);
}
const C = /* @__PURE__ */ o(i, [["render", f]]);
export {
  C as default
};
